import type { ClosingPackageTaskType } from './closingPackageTaskTypes';
import { CLOSING_PACKAGE_TASK_TYPE } from './closingPackageTaskTypes';

/** Workspace modal kind — maps 1:1 to shell component. */
export type ClosingPackageModalKind =
  | 'formation'
  | 'send-scans'
  | 'client-approval'
  | 'revision'
  | 'prepare-originals'
  | 'send-originals'
  | 'client-receipt'
  | 'send-via-edo'
  | 'confirm-edo-receipt';

export const CLOSING_PACKAGE_TASK_TO_MODAL_KIND: Readonly<
  Record<ClosingPackageTaskType, ClosingPackageModalKind>
> = {
  [CLOSING_PACKAGE_TASK_TYPE.FORM_CLOSING_PACKAGE]: 'formation',
  [CLOSING_PACKAGE_TASK_TYPE.SEND_SCANS_TO_CLIENT]: 'send-scans',
  [CLOSING_PACKAGE_TASK_TYPE.WAIT_CLIENT_APPROVAL]: 'client-approval',
  [CLOSING_PACKAGE_TASK_TYPE.REVISE_CLOSING_PACKAGE]: 'revision',
  [CLOSING_PACKAGE_TASK_TYPE.PREPARE_ORIGINALS]: 'prepare-originals',
  [CLOSING_PACKAGE_TASK_TYPE.SEND_ORIGINALS]: 'send-originals',
  [CLOSING_PACKAGE_TASK_TYPE.CONFIRM_CLIENT_RECEIPT]: 'client-receipt',
  [CLOSING_PACKAGE_TASK_TYPE.SEND_VIA_EDO]: 'send-via-edo',
  [CLOSING_PACKAGE_TASK_TYPE.CONFIRM_EDO_RECEIPT]: 'confirm-edo-receipt',
};

export function resolveClosingPackageModalKind(
  taskType: ClosingPackageTaskType
): ClosingPackageModalKind {
  return CLOSING_PACKAGE_TASK_TO_MODAL_KIND[taskType];
}

export const CLOSING_PACKAGE_MODAL_TITLES: Readonly<Record<ClosingPackageModalKind, string>> = {
  formation: 'Подтвердить формирование комплекта',
  'send-scans': 'Отправить сканы клиенту',
  'client-approval': 'Зарегистрировать ответ клиента',
  revision: 'Доработка комплекта',
  'prepare-originals': 'Подготовить оригиналы',
  'send-originals': 'Отправить оригиналы клиенту',
  'client-receipt': 'Подтвердить получение оригиналов',
  'send-via-edo': 'Отправить документы через ЭДО',
  'confirm-edo-receipt': 'Подтвердить получение документов по ЭДО',
};
